import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseModel } from '../../models/response.model';
import { appEnv } from '../../../app.config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerBranchService {

  constructor(
    private http: HttpClient
  ) { }

  getByBranchUuid (uniqId: string = '') {
    return this.http.get<ResponseModel>(`${appEnv.api}customer/branch?uuid=${uniqId}`);
  }

  /** Companies (Sales CRM) board - every branch, unpaginated (mirrors driver/data-table). */
  getDataTable (): Observable<ResponseModel> {
    return this.http.get<ResponseModel>(`${appEnv.api}customer/branch/data-table`);
  }

  /** Companies (Sales CRM) - stage/deal-detail patch only; server-side whitelisted. */
  updateCrmFields (uniqId: string = '', data: Record<string, any> = {}): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(`${appEnv.api}customer/branch/crm-update`, { uuid: uniqId, ...data });
  }

  updateProfile (uniqId: string = '', data: Array<any> = []) {
    return this.http.post<ResponseModel>(`${appEnv.api}customer/branch/profile/update?uuid=${uniqId}`, data);
  }

  updateContrators (uniqId: string = '', data: Array<any> = []) {
    return this.http.post<ResponseModel>(`${appEnv.api}customer/branch/add-contractors?uuid=${uniqId}`, data);
  }

  createManagers (branchId: number = 0, userIds: number[] = []): Observable<ResponseModel> {
    return this.http.put<ResponseModel>(`${appEnv.api}customer/branch/create-managers`, {branchId, userIds});
  }

  /** Companies CRM's Company Tree - every branch's id/name/parent, flat. */
  getHierarchy (): Observable<ResponseModel> {
    return this.http.get<ResponseModel>(`${appEnv.api}customer/branch/hierarchy`);
  }

  /** Companies CRM's Company Tree - assign (parentUuid) or clear (null) a branch's parent. */
  setParent (uuid: string, parentUuid: string | null): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(`${appEnv.api}customer/branch/set-parent`, { uuid, parentUuid });
  }

  /** Admin panel's notification bell - companies created via the public
   *  self-service registration form, newest first. */
  getRecentRegistrations (): Observable<ResponseModel> {
    return this.http.get<ResponseModel>(`${appEnv.api}customer/branch/recent-registrations`);
  }

  /** Companies (Sales CRM) - "Delete" action. Works whether the uuid is
   *  currently a lead or an already-active branch (server-side dual
   *  resolve) - soft-delete, not permanent. */
  delete (uuid: string): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(`${appEnv.api}customer/branch/delete`, { uuid });
  }

  /** Customer CRM "Delete" - removes the company's lead and, if promoted,
   *  its customer_branch too (delete() above only ever removes one, which
   *  left a promoted company's card on the board). */
  crmDelete (uuid: string): Observable<ResponseModel> {
    return this.http.delete<ResponseModel>(`${appEnv.api}customer/branch/${uuid}/crm-delete`);
  }
}
